// extracted by mini-css-extract-plugin
export default {"trendingSubCategoriesStack":"TrendingSubCategoriesPage_trendingSubCategoriesStack__B3zKj"};